import React, { Component } from 'react'
import { Breadcrumb } from 'hljd'
import OrderBase from './OrderBase'
import OrderDynamic from './OrderDynamic'
import Styles from './style.module.less'

import { observer } from 'mobx-react'
import store from './store'
import cid from './OrderDynamic/store'

@observer
export default class extends Component {
  constructor(props) {
    super(props)
    const {
      params: { id }
    } = this.props
    store.id = id
  }
  componentDidMount() {
    // store.GetAssigns('id='+this.props.params.id)
    cid.id = this.props.params.id
  }
  render() {
    return (
      <div className={Styles.orderInfo}>
        <div className={Styles.tipPath}>
          <Breadcrumb separator=">">
            <Breadcrumb.Item href="#/localMerchant/myOrder?tab=all&status=">
              我的订单
            </Breadcrumb.Item>
            <Breadcrumb.Item>订单详情</Breadcrumb.Item>
          </Breadcrumb>
        </div>
        <div className={Styles.orderMain}>
          <div className={Styles.mainLeft}>
            <OrderBase />
          </div>
          <div className={Styles.mainRigth}>
            <OrderDynamic />
          </div>
        </div>
      </div>
    )
  }
}
